/**
 * Hook factory - Tạo hooks cho API instance
 */

'use client';

import { useGet } from './use-get';
import { useMutation } from './use-mutation';
import type {
  UseGetOptions,
  UseGetResult,
  UseMutationOptions,
  UseMutationResult,
  RequestOptions,
} from '../types';
import type { HttpClient } from '../https/client';

/**
 * Tạo hooks cho một HTTP client instance
 */
export function createHooks(client: HttpClient) {
  return {
    /**
     * GET hook
     */
    useGet<TData = unknown>(
      path: string,
      query?: RequestOptions['query'],
      options?: UseGetOptions
    ): UseGetResult<TData> {

      return useGet(client, path, query, options);
    },

    /**
     * POST hook
     */
    usePost<TData = unknown, TVariables = unknown>(
      path: string,
      options?: UseMutationOptions<TData, TVariables>
    ): UseMutationResult<TData, TVariables> {

      return useMutation(client, 'POST', path, options);
    },

    /**
     * PUT hook
     */
    usePut<TData = unknown, TVariables = unknown>(
      path: string,
      options?: UseMutationOptions<TData, TVariables>
    ): UseMutationResult<TData, TVariables> {

      return useMutation(client, 'PUT', path, options);
    },

    /**
     * PATCH hook
     */
    usePatch<TData = unknown, TVariables = unknown>(
      path: string,
      options?: UseMutationOptions<TData, TVariables>
    ): UseMutationResult<TData, TVariables> {

      return useMutation(client, 'PATCH', path, options);
    },

    /**
     * DELETE hook
     */
    useDelete<TData = unknown, TVariables = unknown>(
      path: string,
      options?: UseMutationOptions<TData, TVariables>
    ): UseMutationResult<TData, TVariables> {

      return useMutation(client, 'DELETE', path, options);
    },
  };
}
